import { render, staticRenderFns } from "./communitDynamic.vue?vue&type=template&id=3817756b"
import script from "./communitDynamic.vue?vue&type=script&lang=js"
export * from "./communitDynamic.vue?vue&type=script&lang=js"
import style0 from "./communitDynamic.vue?vue&type=style&index=0&id=3817756b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports